module.exports = __webpack_public_path__ + "media/application/images/demo/wall1_m-60d1f8e927f71a307f929b4eed418d2b.jpg";